<template>
  <div>
    {{ opinion }}
  </div>
</template>

<script>

// import Opinion from '../../enums/opinion'

export default {
  name: 'OpinionView',
  props: {
    opinion: {
      type: String,
      required: true
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/motions/OpinionView.vue